/**
 * Local favorites + recent product ids per terminal — plan/35 phone rail.
 * Device-local only (no sync); cashiers share a register’s muscle memory.
 */

const FAV_PREFIX = "ix_pos_fav:";
const RECENT_PREFIX = "ix_pos_recent:";

export function favoritesStorageKey(
  companyRef: string,
  terminalId: string,
): string {
  return `${FAV_PREFIX}${companyRef}:${terminalId}`;
}

export function recentStorageKey(
  companyRef: string,
  terminalId: string,
): string {
  return `${RECENT_PREFIX}${companyRef}:${terminalId}`;
}

export function parseIdList(raw: string | null): string[] {
  if (raw == null || raw.trim() === "") return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === "string" && x.length > 0);
  } catch {
    return [];
  }
}

export function serializeIdList(ids: readonly string[]): string {
  return JSON.stringify([...ids]);
}

export function loadIdList(key: string): string[] {
  if (typeof localStorage === "undefined") return [];
  try {
    return parseIdList(localStorage.getItem(key));
  } catch {
    return [];
  }
}

export function saveIdList(key: string, ids: readonly string[]): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(key, serializeIdList(ids));
  } catch {
    /* quota / private mode — ignore */
  }
}
